import Icon from '@/components/ui/AppIcon';

interface StatsSectionProps {
    stats: {
        totalProjects: number;
        happyClients: number;
        avgTrafficIncrease: string;
        avgRankingBoost: string;
    };
}

export default function StatsSection({ stats }: StatsSectionProps) {
    return (
        <div className="bg-gradient-to-br from-brand-primary to-brand-secondary rounded-2xl p-8 mb-12">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
                <div className="text-center">
                    <div className="flex justify-center mb-3">
                        <div className="p-3 bg-white/20 rounded-xl">
                            <Icon name="BriefcaseIcon" size={28} className="text-white" />
                        </div>
                    </div>
                    <div className="text-4xl font-bold text-white mb-1">{stats.totalProjects}+</div>
                    <div className="text-sm text-white/80">Projects Completed</div>
                </div>

                <div className="text-center">
                    <div className="flex justify-center mb-3">
                        <div className="p-3 bg-white/20 rounded-xl">
                            <Icon name="UserGroupIcon" size={28} className="text-white" />
                        </div>
                    </div>
                    <div className="text-4xl font-bold text-white mb-1">{stats.happyClients}+</div>
                    <div className="text-sm text-white/80">Happy Clients</div>
                </div>

                <div className="text-center">
                    <div className="flex justify-center mb-3">
                        <div className="p-3 bg-white/20 rounded-xl">
                            <Icon name="ArrowTrendingUpIcon" size={28} className="text-white" />
                        </div>
                    </div>
                    <div className="text-4xl font-bold text-white mb-1">{stats.avgTrafficIncrease}</div>
                    <div className="text-sm text-white/80">Avg Traffic Increase</div>
                </div>

                <div className="text-center">
                    <div className="flex justify-center mb-3">
                        <div className="p-3 bg-white/20 rounded-xl">
                            <Icon name="ChartBarIcon" size={28} className="text-white" />
                        </div>
                    </div>
                    <div className="text-4xl font-bold text-white mb-1">{stats.avgRankingBoost}</div>
                    <div className="text-sm text-white/80">Avg Ranking Boost</div>
                </div>
            </div>
        </div>
    );
}